<!-- Search里带箭头图标统一 -->
<template>
    <div class="arrow-button cursor-pointer uk-flex uk-flex-middle" v-on="$listeners">
        <div>
            <slot></slot>
        </div>
        <div class="arrow">
            <i class="el-icon-d-arrow-right" style="color:white"></i>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.arrow-button {
    background-color: var(--primary-color);
    padding: 8px 15px;
    color: white;
    border-radius: 2px;
    .arrow {
        padding-left: 20px;
    }
}
</style>
